import WCCContentPatternRule from './pattern';
import {WCCContentLineBreakBlock} from "../blocks/lineBreak/lineBreak";

export default class WCCContentNewLineReplacementRule extends WCCContentPatternRule {
    protected pattern = /\n/;

    protected process([_]: RegExpExecArray) {
        return new WCCContentLineBreakBlock({ content: '<br />' });
    }
}